import { __decorate } from "tslib";
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { elements } from './sdb-elements.js';
import '@polymer/iron-image/iron-image.js';
/**
 * Modalbox element, used to create an overlay with contentbox
 *
 * @slot - Unnamed slot (default slot), used to slot the modalbox trigger
 * @slot - content, used to slot the content of the modalbox
 *
 */
let SDBContentModalbox = class SDBContentModalbox extends LitElement {
    constructor() {
        super(...arguments);
        this.headline = '';
        this.opened = false;
    }
    render() {
        return html `
            <section @click=${this._openModal}>
                <div>
                    <slot></slot>
                </div>
            </section>

            <div id="modal" ?opened=${this.opened}>
                <div class="overlay" @click="${this._openModal}"></div>
                <div class="modal-content">
                    <div class="modal-titlebar">
                        <div class="modal-title">${this.headline}</div>
                        <sdb-content-icon
                            size="20"
                            icon="fal fa-xmark"
                            @click=${this._openModal}
                        ></sdb-content-icon>
                    </div>
                    <div class="responsiveContent">
                        <slot name="content"></slot>
                    </div>
                </div>
            </div>
        `;
    }
    _openModal() {
        if (this.opened) {
            this.opened = false;
        }
        else {
            this.opened = true;
        }
    }
};
SDBContentModalbox.styles = [
    elements,
    css `
            :host {
                z-index: 10;
                width: 100%;
                height: 100%;
            }

            :host section {
                width: 100%;
                height: 100%;
                display: block;
            }

            :host section div {
                width: 100%;
                height: 100%;
                display: flex;
                place-items: center;
                justify-content: center;
            }

            div#modal {
                display: none;
                position: fixed;
                z-index: 11;
                padding-top: 100px;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                overflow: auto;
            }

            div#modal div.overlay {
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: rgb(0, 0, 0); /* Fallback color */
                background-color: rgba(0, 0, 0, 0.5); /* Black w/ opacity */
                z-index: 12;
            }

            div#modal[opened] {
                display: block;
            }

            div#modal div.modal-content {
                position: relative;
                background-color: var(--body);
                margin: auto;
                padding: 15px 20px 20px;
                width: 80vw;
                height: auto;
                max-height: 80vh;
                z-index: 13;
                border-top-right-radius: 20px;
                border-bottom-right-radius: 20px;
                border-bottom-left-radius: 20px;
                cursor: default;
            }

            div.responsiveContent {
                position: relative;
                height: auto;
            }

            div.modal-titlebar {
                position: relative;
                display: block;
                height: 35px;
                line-height: 20px;
                width: 100%;
                color: var(--text-primary);
                font-size: 1.1em;
            }

            div.modal-titlebar sdb-content-icon {
                position: absolute;
                top: 0px;
                right: 0px;
            }
        `,
];
__decorate([
    property({ type: String })
], SDBContentModalbox.prototype, "headline", void 0);
__decorate([
    property({ type: Boolean })
], SDBContentModalbox.prototype, "opened", void 0);
SDBContentModalbox = __decorate([
    customElement('sdb-content-modalbox')
], SDBContentModalbox);
export { SDBContentModalbox };
//# sourceMappingURL=sdb-content-modalbox.js.map